const $ = require('jquery');

/**
 * updateRowtableSticky
 */
window.updateRowtableSticky = function () {
    // row-table sticky update top
    if ($('.row-table__head--sticky').length) {
        let stickyTop = 0;
        let stickyElementArray = ['#app__header', '.content-group-filter'];
        $.each(stickyElementArray, function (index, value) {
            if ($(value).length) {
                stickyTop += $(value).outerHeight();
            }
        });
        $(':root')[0].style.setProperty('--row-table-sticky-top', stickyTop + 'px');

        // resize event
        const bodyElement = $('body');
        if (!bodyElement.hasClass('updateRowtableSticky-init')) {
            bodyElement.addClass('updateRowtableSticky-init');
            $(window).resize(function () {
                updateRowtableSticky();
            });
        }
    }
};